module.exports = __webpack_public_path__ + "static/media/PTO Off.a172e124.svg";